import { render, staticRenderFns } from "./ProjectEditDialog.vue?vue&type=template&id=48169e93&scoped=true"
import script from "./ProjectEditDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectEditDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48169e93",
  null
  
)

export default component.exports